/* eslint-disable prettier/prettier */
import { mobilePageTitleAtom } from 'config/store'
import { useAtom } from 'jotai'
import SearchBar from 'pages/HomePage/components/SearchBar'
import { useEffect, useState } from 'react'
import { Container, Dropdown, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import noDataIcon from 'assets/images/profilemobile-gifthist-nodata.svg'
import { useQuery } from 'react-query'
import { getGiftHistQuery } from 'dataLayer/user'
// import { RANKING } from 'pages/ProfilePage/components/GiftHist'

function GiftHistMobile({ title }) {
	const { t } = useTranslation()
	const RANKING = {
		1: `${t('profile.gift_hist.today')}`,
		2: `${t('profile.gift_hist.this_week')}`,
		3: `${t('profile.gift_hist.this_month')}`,
	}

	const [dateFilter, setDateFilter] = useState(3)
	const { data: giftHist } = useQuery(getGiftHistQuery(dateFilter, 0, 10))

	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	useEffect(() => {
		setMobilePageTitle(title)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	// TODO: Search and filter date dropdown mobile

	return (
		<Container fluid className="profilepage-content mobile">
			<div className="search-bar gift-hist mobile">
				<SearchBar type="text" placeholder={t('profile.gift_hist.search')} />
				<Dropdown align="end">
					<Dropdown.Toggle>{RANKING[dateFilter]}</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item
							onClick={() => setDateFilter(Object.keys(RANKING)[2])}
						>
							{t('profile.gift_hist.this_month')}
						</Dropdown.Item>
						<Dropdown.Item
							onClick={() => setDateFilter(Object.keys(RANKING)[1])}
						>
							{t('profile.gift_hist.this_week')}
						</Dropdown.Item>
						<Dropdown.Item
							onClick={() => setDateFilter(Object.keys(RANKING)[0])}
						>
							{t('profile.gift_hist.today')}
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</div>
			<Row
				className={`profilepage-content__body 
				${giftHist?.length > 0 ? 'gifthist' : 'no-gifthist'
					} mobile mt-5 px-0 px-sm-auto`}
			>
				{giftHist?.length > 0 ? (
					giftHist?.map(item => {
						return (
							<div
								key={item?.id}
								className="reward"
								style={{
									backgroundImage: `url(${item?.image})`,
								}}
							>
								<div className="reward-title">
									<p>{item?.name}</p>
									<p>{item?.description}</p>
								</div>
								<div className="reward-date">
									{new Intl.DateTimeFormat('lo-LA').format(
										new Date(item?.received_time),
									)}
								</div>
							</div>
						)
					})
				) : (
					<img src={noDataIcon} alt="No reward is found" />
				)}
			</Row>
		</Container>
	)
}

export default GiftHistMobile
